import { jsx as _jsx } from "react/jsx-runtime";
import { getPagingInfo, } from '@dossierhq/core';
import { ButtonDropdown } from '@dossierhq/design';
import { numberWithThousandsSeparator } from '../../utils/NumberDisplayUtils.js';
export function ConnectionPagingCount({ connection, paging, pagingCount, totalCount, onPagingChange, }) {
    const currentPage = connection?.edges.length && totalCount !== null
        ? `${connection.edges.length} of ${numberWithThousandsSeparator(totalCount)}`
        : pagingCount;
    const items = [
        { id: '25', count: 25 },
        { id: '50', count: 50 },
        { id: '75', count: 75 },
        { id: '100', count: 100 },
    ];
    return (_jsx(ButtonDropdown, { up: true, sneaky: true, activeItemIds: [String(pagingCount)], items: items, renderItem: (item) => item.count, onItemClick: ({ count }) => {
            const pagingInfo = getPagingInfo(paging);
            const newPaging = { ...paging };
            if (pagingInfo.isOk() && !pagingInfo.value.forwards) {
                newPaging.last = count;
            }
            else {
                newPaging.first = count;
            }
            onPagingChange(newPaging);
        }, children: currentPage }));
}
//# sourceMappingURL=ConnectionPagingCount.js.map